import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SLICE_BASE_NAME } from './constant';
import { UserSchemaType } from './user.schema';

const initialState: UserSchemaType = {
  id: '',
  email: '',
  permissions: [],
  isAuthenticated: false,
  name: '',
  role: {
    id: '',
    name: '',
    description: '',
  },
};

const userSlice = createSlice({
  name: `${SLICE_BASE_NAME}/user`,
  initialState: initialState satisfies UserSchemaType,
  reducers: {
    setUser(state, action: PayloadAction<UserSchemaType>) {
      state.name = action.payload.name;
      state.id = action.payload.id;
      state.email = action.payload.email;
      state.phone_number = action.payload.phone_number;
      state.permissions = action.payload.permissions;
      state.isAuthenticated = true;
      state.role = action.payload.role;
    },

    removeUser(state) {
      state.id = '';
      state.name = '';
      state.email = '';
      state.phone_number = '';
      state.permissions = [];
      state.isAuthenticated = false;
      state.role = {
        id: '',
        name: '',
        description: '',
      };
    },
  },
});

export const { setUser, removeUser } = userSlice.actions;
export default userSlice.reducer;
